import { log } from '../plugins/helpers'

export default {

    namespaced: true,

    state: {
        exam_results: null
    },

    mutations: {
        SET_RESULTS(state, payload) {
            state.exam_results = payload
            log('exam results', payload)
        }
    },

    actions: {

        setResults({ commit }, payload) {
            commit('SET_RESULTS', payload)
        }


    }

}